module.exports.mordred = {
  vi: {
    title: 'Mordred trong Avalon: năng lực và chiến thuật',
    description:
      'Mordred làm gì trong Avalon? Tìm hiểu vì sao Merlin không thấy hắn, hắn biết những người chơi Ác nào và khi nào chọn Thành công hoặc Thất bại cho Nhiệm vụ.',
    keywords: ['Mordred', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Mordred em Avalon: habilidades e estratégia',
    description:
      'O que Mordred faz em Avalon? Entenda por que Merlin não o vê, quais jogadores do mal ele conhece e quando escolher Sucesso ou Falha.',
    keywords: ['Mordred', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Mordred in Avalon: Abilities & Strategy',
    description:
      'What does Mordred do in Avalon? Learn why Merlin cannot see him, which evil players he knows, and when to choose Success or Fail on a mission.',
    keywords: ['Mordred', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Мордред в Авалоне: способности и стратегия',
    description:
      'Что делает Мордред в Авалоне: почему его не видит Мерлин, каких злых игроков он знает и когда выбирать успех или провал миссии.',
    keywords: ['Мордред', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆莫德雷德：角色能力與玩法策略',
    description: '阿瓦隆莫德雷德有什麼能力？了解梅林為什麼看不到他、他能看到哪些壞人，以及任務中選擇成功或失敗的取捨。',
    keywords: ['莫德雷德', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆莫德雷德：角色能力与玩法策略',
    description: '阿瓦隆莫德雷德有什么能力？了解梅林为什么看不到他、他能看到哪些坏人，以及任务中选择成功或失败的取舍。',
    keywords: ['莫德雷德', '角色', '规则', '建议'],
  },
  es: {
    title: 'Mordred en Avalon: habilidades y estrategia',
    description:
      '¿Qué hace Mordred en Avalon? Por qué Merlín no lo ve, qué jugadores del mal conoce y cuándo elegir Éxito o Fracaso en una misión.',
    keywords: ['Mordred', 'Rol', 'Reglas', 'Consejos'],
  },
};
